export const currencyMap = {
	inr: { symbol: '₹', abbreviation: 'INR' },
	usd: { symbol: '$', abbreviation: 'USD' },
	cad: { symbol: '$', abbreviation: 'CAD' },
	aed: { symbol: 'د.إ', abbreviation: 'AED' }
};

